exports.components = {
  "component---src-pages-en-js": () => import("./../../../src/pages/en.js" /* webpackChunkName: "component---src-pages-en-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-zh-js": () => import("./../../../src/pages/zh.js" /* webpackChunkName: "component---src-pages-zh-js" */)
}

